import { Trans } from '@lingui/macro';
import { observer } from 'mobx-react-lite';
import React, { FC, useState, useEffect, useContext } from 'react'
import Modal from 'react-modal';
import { Toast } from 'react-bootstrap';
import { Context } from '../../..';
import { ModalPopover } from './modal-popover';
import { DocumentTypeModal } from './DocumentTypeModal';
import { DocumentChapterModal } from './DocumentChapterModal';
import { DocumentPublisherModal } from './DocumentPublisherModal';
import { DocumentStatusModal } from './DocumentStatusModal';
import DocumentsService from '../../../services/DocumentsService';
import { docTypes } from '../../types/docTypes';
import { DocumentPointModal } from './DocumentPointModal';
import { API_URL } from '../../../appConfig';

const Doc: FC<any> = observer(({ doc, setDelDocId, setDelDocModal }) => {

    const [typeNames, setTypeName] = useState<any>([]);

    useEffect(() => {
        let typesName: string[] = []
        doc['type'].forEach((num: number) => {
            typesName.push(docTypes[num - 1])
        })
        setTypeName(typesName);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className='row'>
            <div className="col">
                <a href={API_URL + doc['url']} className="doc-link" target="_blank" rel="noreferrer" download>
                    <div className="h6">{doc['name']}</div>
                    <div>
                        <span className="small me-1 text-primary"><Trans>Date</Trans>:</span>
                        <span className="small me-1">{doc['date']}</span>
                        <span className="small me-1 text-primary"><Trans>Chapter</Trans>:</span>
                        <span className="small me-1">{doc['chapter']['chapter']}</span>
                        <span className="small me-1 text-primary"><Trans>Publisher</Trans>:</span>
                        <span className="small me-1">{doc['publisher']['publisher']}</span>
                        <span className="small me-1 text-primary"><Trans>Status</Trans>:</span>
                        <span className="small me-1">{doc['status']['status']}</span>
                        <span className="small me-1 text-primary"><Trans>Type</Trans>:</span>
                        <span className="small me-1">{typeNames.join(', ')}</span>
                    </div>
                </a>
            </div>

            <div className="col-md-1">
                <i className='icon trash' onClick={() => {
                    setDelDocId(doc['id']);
                    setDelDocModal(true);
                }} />
            </div>
            <hr />
        </div>

    )
});

interface DocsProps {
    fix: boolean;
    setFix: (value: boolean) => void;
}

const Docs: FC<DocsProps> = observer(({ fix, setFix }) => {
    const { store } = useContext(Context);
    const [documents, setDocuments] = useState<[]>([]);
    const [delDocId, setDelDocId] = useState<number>(-1);
    const [delDocModal, setDelDocModal] = useState<boolean>(false);

    const getDocs = async () => {
        const res = await DocumentsService.getDocuments()
        setDocuments(res.data.results);
    };

    useEffect(() => {
        getDocs();
        setFix(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fix])

    const getItems = () => documents.sort((a, b) => b['id'] - a['id']).map((doc, i) => {
        return <Doc key={i} {...{ doc, setDelDocId, setDelDocModal }} />
    });

    const deleteDoc = async () => {
        await DocumentsService.removeDocument(delDocId);
        setFix(true);
        setDelDocModal(false);
        setDelDocId(-1);
    };


    return (
        <div>
            {getItems()}
            <ModalPopover
                toggle={delDocModal}
                setToggle={setDelDocModal}
                title={store.lang === 'ba' ? 'Файлды алып ташлау' : store.lang === 'ru' ? 'Удаление файла' : 'Deleting a file'}
                modalContent={<Trans>Do you want to delete a file?</Trans>}
                clickedButtonOne={() => deleteDoc()}
                clickedButtonTwo={() => { setDelDocModal(false); setDelDocId(-1); }}
                ButtonOneValue={store.lang === 'ba' ? 'Эйе' : store.lang === 'ru' ? 'Да' : 'Yes'}
                ButtonTwoValue={store.lang === 'ba' ? 'Кире ҡайтарыу' : store.lang === 'ru' ? 'Отмена' : 'Cancel'}
            />
        </div>
    )
});

interface ModalProps {
    doc: any;
    toggle: boolean;
    setToggle: (value: boolean) => void;
}

export const DocsEditModal: FC<ModalProps> = props => {
    const { doc, toggle, setToggle } = props;
    const { store } = useContext(Context);
    const [docData, setDocData] = useState<any>(doc);
    const [fix, setFix] = useState<boolean>(false);
    const [cleanData, setCleanData] = useState<boolean>(false);
    const [showToast, setShowToast] = useState(false);
    const [toastInfo, setToastInfo] = useState('');
    const now = new Date();
    const date = now.toISOString().substring(0, 10);

    const onRequestClose = () => {
        setToggle(false);
    };

    const onChange = (e: React.ChangeEvent<any>) => {
        setDocData({ ...docData, [e.target.name]: e.target.value.substring(0, 255) });
    };

    const saveDoc = async () => {
        console.log(docData)
        const formData = new FormData();
        formData.append('name', docData['name']);
        formData.append('date', docData['date']);
        formData.append('type', docData['type']);
        formData.append('point', docData['point']);
        formData.append('chapter', docData['chapter']);
        formData.append('publisher', docData['publisher']);
        formData.append('status', docData['status']);
        await DocumentsService.updateDocument(doc['id'], formData);
        setFix(true);
        setCleanData(true);
        setDocData({});
        setToastInfo(store.lang === 'ba' ? 'Документ өҫтәлде' : store.lang === 'ru' ? 'Документ сохранен' : 'Document has been saved');
        setShowToast(true);
    };

    useEffect(() => {
        if (document.getElementById('name') as HTMLInputElement) {
            (document.getElementById('name') as HTMLInputElement).value = '';
        };
        if (document.getElementById('file') as HTMLInputElement) {
            (document.getElementById('file') as HTMLInputElement).value = '';
        };
        if (document.getElementById('date') as HTMLInputElement) {
            (document.getElementById('date') as HTMLInputElement).value = '';
        };
        setCleanData(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cleanData]);


    return (
        <Modal isOpen={toggle} onRequestClose={onRequestClose} ariaHideApp={false} className='Modal'>
            <div className="row Modal__Head d-flex">
                <div className="col">
                    <button type='button' className='btn btn-success' onClick={() => setToggle(false)}>
                        <i className="icon close" />
                        <Trans>Close</Trans>
                    </button>
                </div>
                <div className="col text-end"><Trans>Setting up documents</Trans></div>
            </div>
            <form className="Modal__Body">
                <div className="row form-group">
                    <div className="col-md-7">

                        {/*<div className="row mb-3">*/}
                        {/*    <label htmlFor="author" className="col-sm-2 col-form-label"><Trans>File</Trans></label>*/}
                        {/*    <div className="col-sm-9">*/}
                        {/*        <input className="form-control" type='file' name="file" id="file" onChange={(e) => onChangeFile(e)} />*/}
                        {/*    </div>*/}

                        {/*</div>*/}
                        <div className="row mb-3">
                            <label htmlFor="header" className="col-sm-2 col-form-label"><Trans>Name</Trans></label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" defaultValue={docData.name} name="name" id="name" onChange={(e) => onChange(e)} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="header" className="col-sm-2 col-form-label"><Trans>Date</Trans></label>
                            <div className="col-sm-9">
                                <input type="date" className="form-control" name="date" id="date" defaultValue={docData.date ? docData.date : date} onChange={(e) => onChange(e)} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="header" className="col-sm-2 col-form-label"><Trans>Type</Trans></label>
                            <div className="col-sm-9">
                                <DocumentTypeModal {...{ docData, setDocData, cleanData, setCleanData }} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="header" className="col-sm-2 col-form-label"><Trans>Grade</Trans></label>
                            <div className="col-sm-9">
                                <DocumentPointModal {...{ docData, setDocData, cleanData, setCleanData }} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="header" className="col-sm-2 col-form-label"><Trans>Chapter</Trans></label>
                            <div className="col-sm-9">
                                <DocumentChapterModal {...{ docData, setDocData, cleanData, setCleanData }} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="header" className="col-sm-2 col-form-label"><Trans>Publisher</Trans></label>
                            <div className="col-sm-9">
                                <DocumentPublisherModal {...{ docData, setDocData, cleanData, setCleanData }} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="header" className="col-sm-2 col-form-label"><Trans>Status</Trans></label>
                            <div className="col-sm-9">
                                <DocumentStatusModal {...{ docData, setDocData, cleanData, setCleanData }} />
                            </div>
                        </div>

                        <button type="button" className="btn btn-success" onClick={() => saveDoc()}><Trans>Save</Trans></button>
                    </div>
                    <div className="col-md-5">
                        <Docs {...{ fix, setFix }} />
                    </div>
                </div>
            </form>
            <Toast className='toast p-0 border-success' bg='light' onClose={() => setShowToast(false)} show={showToast} delay={5000} autohide>
                <Toast.Header className='bg-success m-0 text-light'>
                    <strong className="me-auto"><Trans>Information</Trans></strong>
                </Toast.Header>
                <Toast.Body><strong>{toastInfo}</strong></Toast.Body>
            </Toast>
        </Modal>
    );
};